// Konfiguracja CSS Grid dla wirtualizowanej tabeli produktów
export const COLUMN_TEMPLATE = '25px 30px 35px 1fr 90px 80px 70px 65px 50px 40px 80px';
export const ROW_HEIGHT = 38;
export const HEADER_HEIGHT = 36;
